module.exports = __webpack_public_path__ + "media/images/get-involved/school_governors-3fd3d80bb478049dd0f37d75cf41388c.svg";